import React from 'react'

export default function ServicesBanner() {
  return (
    <div className=''>
      <div className="servicespage-banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="head-banner-posi">
                <h1 className="banner-heading after-line ">Service</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
